// extracted by mini-css-extract-plugin
export default {"page":"wM","freeShippingContainer":"xM","customizeContainer":"yM","customizeHeader":"zM","fadein":"AM","customizeText":"BM","hidden":"CM","productcard":"EM","accordeonscontainer":"FM","freeShipping":"GM","mainpart":"HM"};
    if(module.hot) {
      // 1713996748660
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  